var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 24939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9020"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111820",
    d: "M17.543 3.25a.84.84 0 0 1 .6.247l2.463 2.47a.84.84 0 0 1 0 1.191l-7.9 7.907a.84.84 0 0 1-.364.214l-3.459.988a.842.842 0 0 1-1.041-1.041l.988-3.459a.84.84 0 0 1 .214-.364l7.903-7.906a.84.84 0 0 1 .596-.247m1.28 3.313-1.28-1.28-7.157 7.157-.512 1.791 1.791-.512Z",
    "data-name": "Path 5902"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111820",
    d: "M19.957 20.751H3.145V3.892h8.713V5.58H4.83v13.486h13.443v-5.777h1.685Z",
    "data-name": "Path 5903"
  }))));
};
export { SvgEdit as ReactComponent };
export default "/_next/static/images/edit.svg";